var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrimaryInlineJingle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H31.5V39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.5 2.067 2.067 0.5 4 0.5Z",
    fill: "#E8E8E8",
    stroke: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 26C13.97 26 13.75 25.78 13.75 25.5C13.75 25.22 13.97 25 14.25 25C17.42 25 20 22.48 20 19.39C20 16.97 17.98 15 15.5 15C13.57 15 12 16.53 12 18.41C12 19.86 13.21 21.04 14.7 21.04C15.84 21.04 16.76 20.14 16.76 19.04C16.76 18.21 16.07 17.54 15.21 17.54C14.58 17.54 14.07 18.03 14.07 18.64C14.07 18.92 13.85 19.14 13.57 19.14C13.29 19.14 13.07 18.92 13.07 18.64C13.07 17.48 14.03 16.54 15.21 16.54C16.62 16.54 17.76 17.66 17.76 19.04C17.76 20.7 16.39 22.04 14.7 22.04C12.66 22.04 11 20.41 11 18.41C11 15.98 13.02 14 15.5 14C18.53 14 21 16.42 21 19.39C21 23.03 17.97 26 14.25 26Z",
    fill: "#0F141A",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryInlineJingle);
export default __webpack_public_path__ + "static/media/Primary_Inline_Jingle.aac75b3cf0f46329182dda1a8722cda5.svg";
export { ForwardRef as ReactComponent };